import * as React from 'react';
import cx from 'clsx';

import styles from './LiveTablePlayers.module.scss';
import { AccountLi, ArrowRight } from '../../icons';

const PLAYER_WIDTH = 14 + 2 * 7;
const WRAPPER_PADDING = 2 * 5;

interface LiveTablePlayersProps {
  seats: number;
  players?: number;
  tileWidth?: number;
  fullPlayersText: string;
}

const LiveTablePlayers = ({
  seats,
  players = 0,
  tileWidth = 320,
  fullPlayersText = 'Bet behind',
}: LiveTablePlayersProps) => {
  const takenSeats = new Array(seats).fill(1);
  let playersArray = Array.from(Array(seats).keys());
  const amount = Math.floor((tileWidth - WRAPPER_PADDING) / PLAYER_WIDTH);

  for (let i = 0; i < players; ++i) {
    const seat = playersArray[Math.floor(Math.random() * playersArray.length)];
    playersArray = playersArray.filter(v => v !== seat);
    takenSeats[seat] = 0;
  }

  return (
    <div className={cx(styles.container)}>
      <div className={styles.playersWrapper}>
        {takenSeats.slice(0, amount).map((player, i) => (
          <AccountLi
            key={i}
            className={cx(
              styles.player,
              player === 0 ? styles.playerRed : styles.playerGreen
            )}
          />
        ))}
      </div>
      {players >= seats && (
        <div className={styles.betBehind}>
          <span>{fullPlayersText}</span>
          <ArrowRight className={styles.arrow} />
        </div>
      )}
    </div>
  );
};

export default LiveTablePlayers;
